import {
  getObject,
  getOptionalObject,
  getBoolean,
  getOptionalBoolean,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "./code";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface GridOptionV1DTO {
  code: CodeDTO;
  option?: SurveyLocalizedTextDTO | null;
  isUnanswered?: boolean | null;
}

export class GridOptionV1 {
  readonly isGridOptionV1GridOptionV1: boolean = true;

  readonly code: Code;
  readonly option: SurveyLocalizedText | null;
  readonly isUnanswered: boolean | null;


  constructor(
  code: Code, 
  option: SurveyLocalizedText | null = null, 
  isUnanswered: boolean | null = null
  ) {
    this.code = code;
    this.option = option;
    this.isUnanswered = isUnanswered;
  }

  static fromDTO(dto: GridOptionV1DTO): GridOptionV1 {
    const code = Code.fromDTO(getObject(dto, "code", InvalidGridOptionV1CodeError));
    let option = getOptionalObject(dto, "option");
    if(option !== undefined && option !== null) {
      option = SurveyLocalizedText.fromDTO(getObject(dto, "option", InvalidGridOptionV1OptionError));
    }
    const isUnanswered = getOptionalBoolean(dto, "isUnanswered", InvalidGridOptionV1IsUnansweredError);
    return new GridOptionV1(
      code,
      option,
      isUnanswered
    );
  }

  toDTO(): GridOptionV1DTO {
    const dto: GridOptionV1DTO = {
        code: this.code.toDTO(),
    };
    if (this.option !== undefined && this.option !== null){
      dto.option = this.option.toDTO();
    }
    if (this.isUnanswered !== undefined && this.isUnanswered !== null){
      dto.isUnanswered = this.isUnanswered;
    }
    return dto;
  }
  }

GridOptionV1.prototype.toString = function toString(): string {
  return `GridOptionV1(code='${this.code}',option='${this.option}',isUnanswered='${this.isUnanswered}')`;
};

export class InvalidGridOptionV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOptionV1Error";
  }
}
export class InvalidGridOptionV1CodeError extends InvalidGridOptionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOptionV1CodeError";
  }
}

export class InvalidGridOptionV1OptionError extends InvalidGridOptionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOptionV1OptionError";
  }
}

export class InvalidGridOptionV1IsUnansweredError extends InvalidGridOptionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOptionV1IsUnansweredError";
  }
}
